import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const ResetPasswordDiv = styled(BaseStyles.Div)`
    padding: 2rem;
    width:  100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ResetPasswordComponentsDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 3.8px rgba(0, 0, 0, 0.022),
    0 0px 8.3px rgba(0, 0, 0, 0.031),
    0 0px 14.9px rgba(0, 0, 0, 0.039),
    0 0px 30.5px rgba(0, 0, 0, 0.048),
    0 0px 104px rgba(0, 0, 0, 0.07)
    ;
    margin: auto;
    flex: 1 1 50rem;
    min-width: 30rem;
    max-width: 50rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.8rem;
    background-color: white;
    padding: 0.75%;
`

export const QuickFillerButtonDiv = styled(BaseStyles.Div)`
    margin-bottom: 7rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ResetPasswordFieldsDiv = styled(BaseStyles.Div)`
    padding: 6rem 2rem;
    width: 100%;
`

export const ResetPasswordFormDiv = styled(BaseStyles.Div)`
    margin: 0rem 2rem;
`

export const ResetPasswordButtonDiv = styled(BaseStyles.Div)`
    margin-top: 8.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const QuickFillerButton = styled.button`
    margin: 0;
    padding: 0;
    color: black;
    background-color: transparent;
    outline-style: none;
    cursor: pointer;
    font-size: 3rem;
    border: none;
    font-weight: bold;
    font-family: "Helvetica Neue";
    &:hover {
        color: #4267B2;
    }
`

export const ResetPasswordTitle = styled.h2`  
    margin: 0;
    padding: 0rem;
    padding-bottom: 6rem;
    font-size: 2.5rem;
    font-weight: 550;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`

export const ResetPasswordInputField = styled(BaseStyles.InputField)`
    font-size: 1.65rem;
    height: 3rem;
    width: 100%;
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;
`

export const ActionButton = styled.button`
    wmargin: 0;
    padding: 0;
    width: 40%;
    height: 3rem;
    font-size: 1.8rem;
    color: black;
    outline-styles: none;
    border-radius: 0.7rem;
    border-style: solid;
    border-width: thin;
    cursor: pointer;
`

export const ResetPasswordButton = styled(ActionButton)`
    background-color: transparent;
    border-color: #4267B2;
    &:hover{
        background-color: #4267B2;
        color: white;
    }
`